import { Component, Input } from '@angular/core';
import { getRetrievalModeHistoryLabelKey, normalizeRetrievalMode } from '../../utils/retrieval-mode.util';

@Component({
  selector: 'app-retrieval-mode-history-notice',
  templateUrl: './retrieval-mode-history-notice.component.html',
  styleUrls: ['./retrieval-mode-history-notice.component.scss']
})
export class RetrievalModeHistoryNoticeComponent {
  @Input() retrievalMode?: string | null;
  /** When true (v3 regulations agent), renders boxed notice with info icon. */
  @Input() boxed = false;

  get labelKey(): string | null {
    return getRetrievalModeHistoryLabelKey(normalizeRetrievalMode(this.retrievalMode));
  }
}
